import React from "react";
import { NavigateFunction } from "react-router-dom";
import { ProjectCardInter } from "../../interface/interface";
import { formatDate } from "../../lib/lib";

type Props = {
  index: number;
  data: ProjectCardInter;
  navigate: NavigateFunction;
  ChangeProjectSts: ((id: string) => void) | undefined;
};

const ProjectFinishCard = ({
  index,
  data,
  navigate,
  ChangeProjectSts,
}: Props) => {
  const {
    prjt_sts_cd,
    prjt_nm,
    rcrt_apply_en_at,
    leadr_usr_nm,
    tot_rcrt_cnt,
    usr_rcrt_cnt,
    prjt_id,
    prjt_type_cd,
  } = data;

  return (
    <div className="finish-card-comp">
      <div className="prjt-finish-title">{prjt_nm}</div>
      <div className="finish-time">{formatDate(rcrt_apply_en_at, "-")}</div>
      <div className="finish-leader">{leadr_usr_nm}</div>
      <div className="finish-num">
        {usr_rcrt_cnt}/{tot_rcrt_cnt}
      </div>
      <div
        className={`prjt-finish-state ${
          prjt_sts_cd === "prjt_sts_rcrt_end" ? "rcrt-end" : ""
        }`}
      >
        {prjt_sts_cd === "prjt_sts_rcrt_end" ? "선정대기" : "선정완료"}
      </div>
      {prjt_sts_cd === "prjt_sts_rcrt_end" ? (
        <>
          {" "}
          <button
            className="rcrt-change-btn"
            onClick={() => {
              if (ChangeProjectSts) {
                ChangeProjectSts(prjt_id);
              }
            }}
          >
            선정완료
          </button>
        </>
      ) : undefined}
      <button
        className={`rcrt-btn ${
          prjt_sts_cd !== "prjt_sts_rcrt_end" ? "detail-btn" : ""
        }`}
        onClick={() => {
          navigate(
            // prjt_sts_cd !== "prjt_sts_rcrt_end"
            // `/${prjt_type_cd}/user/list`,
            `/prjt/list`,
            {
              state: {
                prjt_id,
              },
            }
          );
        }}
      >
        {prjt_sts_cd === "prjt_sts_rcrt_end" ? "선정하기" : "상세보기"}
      </button>
    </div>
  );
};

export default ProjectFinishCard;
